import { getSizeConversion } from 'shared/services/sizeConversion';

export const convertSearchFilterSizeForBuyBar = async ({
  sizeOptions,
  searchFilterSize,
  genderOfProduct,
  productCategoryOfProduct,
  productTypeOfProduct,
  brandOfProduct,
  unitOfProduct,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [_, productType, gender, size] = searchFilterSize.split('_');

  if (productCategoryOfProduct !== 'shoes') {
    // if current product is NOT shoes and the product type is not the same as the filter product type
    // don't do any conversion
    if (productType !== productTypeOfProduct) {
      return '';
    }

    // if current product is NOT shoes and the product type is the same as the filter product type
    // return the value of the size instead of the presentation
    if (productType === productTypeOfProduct) {
      const sizeFromSizeOption = sizeOptions.find(
        (option) => option.presentation?.toLowerCase() === size?.toLowerCase(),
      );

      return sizeFromSizeOption?.value?.toString() || '';
    }
  }

  if (productCategoryOfProduct === 'shoes') {
    // if current product is shoes and the filter type is also sneakers, and gender is the same,
    // just return the size, no need for conversion
    if (productType === 'sneakers' && genderOfProduct === gender) {
      return size;
    }

    // if current product is shoes and the filter type is also sneakers, and gender is not the same,
    // do size conversion
    if (productType === 'sneakers' && genderOfProduct !== gender) {
      try {
        const result = await getSizeConversion({
          userSize: size,
          fromGender: gender,
          toGender: genderOfProduct,
          productType,
          fromUnit: 'US',
          toUnit: unitOfProduct,
          fromBrand: 'default',
          toBrand: brandOfProduct,
        });

        return result?.size || '';
      } catch {
        return '';
      }
    }
  }

  return '';
};
